import React, { useEffect, useState } from 'react';
import CountUp from "react-countup";

export default function HealthcareCounter({data}) {
  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    setIsClient(true);
  }, []);
  return (
    <section className="platform-section">
      <div className="container">
        <div className="row justify-content-center">
          {data?.title && (
            <div className="col-md-12 col-lg-8">
              <div className="heading-text">
                <h4 className="heading center-heading">{data.title}</h4>
              </div>
            </div>
          )}
        </div>
        <div className="row">
          {data.stats.map((item, index) => (
            <div className="col-6 col-md-6 col-lg-3 platform-count" key={index}>
              <div  className={`platform-text ${index === data.stats.length - 1 ? "last-playform" : "" }`}  >
                <div className="heading">
                  {item.prefix && item.prefix}
                  <span className="stat-number">
                    {isClient? <CountUp start={0} end={item.end} duration={7} />: item.end}
                  </span>
                  {item.suffix && item.suffix}
                </div>
                <p dangerouslySetInnerHTML={{ __html: item.text }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
   )
}

